/* eslint-disable */ import { EnumReflection } from '@salsita-ai/platform-project-sdk/domain';
export const ApplicationVersion = '0.0.0';
export const PublishedData = {
    type: 'object',
    properties: {
        customMaterials: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    code: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    length: {
                        type: 'number'
                    },
                    width: {
                        type: 'number'
                    },
                    thickness: {
                        type: 'number'
                    },
                    rawMaterial: {
                        type: 'string',
                        enum: [
                            'brass',
                            'ss304',
                            'ss316',
                            'aluminium'
                        ]
                    },
                    finish: {
                        type: 'string',
                        enum: [
                            'brushed',
                            'milled',
                            'chequer',
                            'propeller'
                        ]
                    },
                    standard: {
                        type: 'boolean'
                    },
                    powderCoatingEnabled: {
                        type: 'boolean'
                    }
                },
                additionalProperties: false,
                required: [
                    'id',
                    'code',
                    'name',
                    'length',
                    'width',
                    'thickness',
                    'rawMaterial',
                    'finish',
                    'standard',
                    'powderCoatingEnabled'
                ]
            }
        },
        countersinks: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    topRadius: {
                        type: 'number',
                        minimum: 0
                    },
                    bottomRadius: {
                        type: 'number',
                        minimum: 0
                    },
                    plateThicknessMin: {
                        type: 'number',
                        minimum: 0
                    },
                    plateThicknessMax: {
                        type: 'number',
                        minimum: 0
                    }
                },
                additionalProperties: false,
                required: [
                    'id',
                    'topRadius',
                    'bottomRadius',
                    'plateThicknessMin',
                    'plateThicknessMax'
                ]
            }
        },
        featureSettings: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    plateType: {
                        type: 'string',
                        enum: [
                            'RoundPlate',
                            'SquarePlate',
                            'RectangularPlate',
                            'KickPlate',
                            'StrikePlate'
                        ]
                    },
                    featureType: {
                        type: 'string',
                        enum: [
                            'BoltHole',
                            'CamlockHole',
                            'CornerBoltHoles',
                            'CornerCountersinkHoles',
                            'CountersinkHole',
                            'DeadboltHole',
                            'EuroCylinderHoleAu',
                            'EuroCylinderHoleEu',
                            'Hole54',
                            'KickPlateBoltHoles',
                            'KickPlateCountersinkHoles',
                            'OvalCylinderHole',
                            'PD7Hole',
                            'PlainCylinderHole',
                            'PlainLocksetHole',
                            'PN6Hole',
                            'RectangularHole',
                            'RimCylinderHole',
                            'SquareHole'
                        ]
                    },
                    anchorPointPosition: {
                        type: 'string',
                        enum: [
                            'topLeft',
                            'top',
                            'topRight',
                            'right',
                            'bottomRight',
                            'bottom',
                            'bottomLeft',
                            'left',
                            'center'
                        ]
                    },
                    offsetX: {
                        type: 'number'
                    },
                    offsetY: {
                        type: 'number'
                    }
                },
                additionalProperties: false,
                required: [
                    'id',
                    'plateType',
                    'featureType',
                    'anchorPointPosition',
                    'offsetX',
                    'offsetY'
                ]
            }
        },
        presetCategories: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    img: {
                        type: 'string'
                    },
                    imgAlt: {
                        type: 'string'
                    },
                    presets: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                configurationId: {
                                    type: 'string'
                                },
                                revisionId: {
                                    type: 'string'
                                },
                                readToken: {
                                    type: 'string'
                                },
                                name: {
                                    type: 'string'
                                },
                                description: {
                                    type: 'string'
                                },
                                img: {
                                    type: 'string'
                                },
                                imgAlt: {
                                    type: 'string'
                                },
                                detailTitle: {
                                    type: 'string'
                                },
                                detailDescription: {
                                    type: 'string'
                                },
                                tags: {
                                    type: 'array',
                                    items: {
                                        type: 'string'
                                    }
                                }
                            },
                            required: [
                                'configurationId',
                                'revisionId',
                                'readToken',
                                'name',
                                'description'
                            ],
                            additionalProperties: false
                        }
                    }
                },
                required: [
                    'id',
                    'name',
                    'presets'
                ],
                additionalProperties: false
            }
        },
        recipes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    configuration: {
                        type: 'object',
                        properties: {
                            modelVersion: {
                                type: 'number'
                            },
                            entities: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        id: {
                                            type: 'string'
                                        },
                                        type: {
                                            type: 'string'
                                        }
                                    },
                                    required: [
                                        'id',
                                        'type'
                                    ],
                                    additionalProperties: true
                                }
                            },
                            rootEntityType: {
                                type: 'string'
                            },
                            recipeIds: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            }
                        },
                        required: [
                            'modelVersion',
                            'entities',
                            'rootEntityType',
                            'recipeIds'
                        ],
                        additionalProperties: false
                    }
                },
                required: [
                    'id',
                    'name',
                    'description',
                    'collection',
                    'configuration'
                ],
                additionalProperties: false
            }
        }
    },
    required: [],
    additionalProperties: false
};
export const SessionData = {
    type: 'object',
    properties: {
        accessToken: {
            type: 'string'
        }
    },
    required: [
        'accessToken'
    ],
    additionalProperties: false
};
export const FrontendData = {};
export const FinalizeData = {
    type: 'object',
    properties: {
        accessToken: {
            type: 'string'
        },
        stepFile: {
            type: 'string'
        },
        quoteId: {
            type: 'number'
        },
        quoteLineId: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ]
        },
        usage: {
            type: 'string'
        },
        materialCode: {
            type: 'string'
        },
        rawMaterial: {
            type: 'string'
        },
        usedCountersinks: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        volume: {
            type: 'number',
            minimum: 0
        }
    },
    required: [
        'accessToken',
        'stepFile',
        'quoteId',
        'quoteLineId',
        'usage',
        'materialCode',
        'rawMaterial',
        'usedCountersinks',
        'volume'
    ],
    additionalProperties: false
};
export const PrefetchedFinalizeData = {};
export const FinalizeResult = {
    type: 'object',
    properties: {},
    required: [],
    additionalProperties: false
};
export const CallbackData = {
    type: 'object',
    properties: {
        accessToken: {
            type: 'string'
        },
        quoteId: {
            type: 'number'
        },
        quoteLineId: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ]
        },
        data: {
            type: 'object',
            properties: {
                configurationId: {
                    type: 'string'
                },
                stepFile: {
                    type: 'string'
                },
                quantity: {
                    type: 'number'
                },
                usage: {
                    type: 'string'
                },
                designSpec: {
                    type: 'object',
                    properties: {
                        height: {
                            type: 'number'
                        },
                        width: {
                            type: 'number'
                        },
                        material: {
                            type: 'string'
                        },
                        holes: {
                            additionalProperties: {
                                type: 'number',
                                minimum: 0
                            }
                        },
                        numBends: {
                            type: 'number'
                        },
                        powderCoating: {
                            type: 'boolean'
                        },
                        handing: {
                            type: 'string'
                        },
                        thickness: {
                            type: 'string'
                        },
                        volume: {
                            type: 'string'
                        },
                        materialName: {
                            type: 'string'
                        },
                        shape: {
                            type: 'string'
                        },
                        finish: {
                            type: 'string'
                        }
                    },
                    additionalProperties: false,
                    required: [
                        'height',
                        'width',
                        'material',
                        'holes',
                        'numBends',
                        'powderCoating',
                        'handing',
                        'thickness',
                        'volume',
                        'materialName',
                        'shape',
                        'finish'
                    ]
                }
            },
            additionalProperties: false,
            required: [
                'configurationId',
                'stepFile',
                'quantity',
                'usage',
                'designSpec'
            ]
        }
    },
    required: [
        'accessToken',
        'quoteId',
        'quoteLineId',
        'data'
    ],
    additionalProperties: false
};
export const BackendData = undefined;
export const NavigationState = new EnumReflection('NavigationState', {
    enum: [
        'Dimensions',
        'Features',
        'FeatureList',
        'Summary',
        'BulkFinalization',
        'Finalization',
        'FinalizationThumbnail'
    ]
});
export const ViewState = new EnumReflection('ViewState', {
    enum: [
        '3d',
        '2d'
    ]
});
export const ToolState = new EnumReflection('ToolState', {
    enum: [
        'Configure',
        'Measure'
    ]
});
export const AdminNavigationState = new EnumReflection('AdminNavigationState', {
    enum: [
        'PresetCategories',
        'Presets',
        'Materials',
        'Countersinks',
        'FeatureSettings'
    ]
});
export const AdminViewState = new EnumReflection('AdminViewState', {
    enum: [
        'Default'
    ]
});

//# sourceMappingURL=application-types.js.map